<template>
    <div class="modal">
        <div class="modal--header">
            <h2>항목목록</h2>
        </div>
        <div class="modal--content" v-if="statItemList.length > 0">
            <ul class="modal--list">
                <li v-for="(statItem, statItemIndex) in statItemList" :key="statItemIndex">
                    <input type="checkbox" v-bind:id="statItem.mapItmNo" v-bind:value="statItem" v-model="selectedStatMenuList" @change="selectStatMenu(statItem, $event)">
                    <label v-bind:for="statItem.mapItmNo">{{ statItem.mapItmOutNm }}</label>
                </li>
            </ul>
            <p class="guide--txt">최대 3개까지만 선택이 가능합니다.</p>
        </div>
        <div class="modal--content" v-else>
            <ul class="modal--list">
                <li><p style="font-size: 17px;font-weight: 400;width:100%;text-align:center">통계분류항목을 선택해야합니다.</p></li>
            </ul>
        </div>
        <div class="modal--footer">
          <button @click="closeModal">닫기</button>
          <button @click="nextModal">다음</button>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { eventBus } from '@/event-bus'

const statItemStore = 'statItemStore'

export default {
  data(){
    return {
      selectedStatMenuList: this.selectedStatItemList
    }
  },
  props: {
    mapSysNo: '',
    statItemList: {},
    selectedStatItemList: {},
  },
  computed: {
    ...mapGetters(statItemStore, {
      statItemMaxCount: 'statItemMaxCount',
      statItemCount: 'statItemCount',
    }),
  },
  created () {
    // console.log('Create ListModal..')
  },
  methods:{
    selectStatMenu (statItem, $event) {
      if ($event.target.checked) {
        if (this.statItemCount >= this.statItemMaxCount) {
          this.selectedStatMenuList.splice(this.selectedStatMenuList.length - 1, 1)
          alert('최대 3개까지만 선택이 가능 합니다.')
          $event.target.checked = false
          return false
        }
      }
      eventBus.$emit('selectStatItem', statItem)
    },

    nextModal: function () {
      this.$FModal.hide()
      setTimeout(() => {
        eventBus.$emit('listNextEvent', this.selectedStatMenuList)
      }, 500)
    },

    closeModal: function () {
      this.$FModal.hide()
    },
  }
}
</script>
<style scoped>
.modal .modal--header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width:100%;
  height:50px;
  line-height: 50px;
  background-image: url("../../../assets/mobile/images/bg_menu_03.png");
  padding:0 15px;
}

.modal--list li input[type='checkbox']:checked+label{
  color: #559fc5;
}

</style>
